import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";

export const edgeStyle = recipe({
  base: {
    lineHeight: 1,
    ":empty": {
      display: "none",
    },
    selectors: {
      "&:has(.add-on)": {
        display: "contents",
      },
    },
  },
  variants: {
    variant: {
      default: {
        flexGrow: 0,
        flexShrink: 0,
      },
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export const edgeContentStyle = recipe({
  base: {
    flexGrow: 1,
    ":empty": { display: "none" },
  },
  variants: {
    hideOverflow: {
      true: { overflow: "hidden" },
    },
  },
});

export const edgeLeadingStyle = style({
  // keep
});
